import { Component, OnInit, OnDestroy, isDevMode } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-broadcasting-new-schedule-dashboard',
  templateUrl: './broadcastings-broadcasting-new-schedule-dashboard.component.html',
  styleUrls: ['./broadcastings-broadcasting-new-schedule-dashboard.component.scss']
})
export class BroadcastingsBroadcastingNewScheduleDashboardComponent implements OnInit, OnDestroy {

  broadcastingid;
  broadcasting;
  getBroadcastingInfoSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private broadcastingsService: BroadcastingsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.broadcastingid = this.activatedRoute.snapshot.params['broadcastingid'];
    this.setBreadcrumb();
    this.getBroadcastingInfo();
  }

  public getBroadcastingInfo() {
    this.getBroadcastingInfoSubscription = this.broadcastingsService.getBroadcastingInfo(this.broadcastingid).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      tap(o => this.broadcasting = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-day', 'schedule-page.new schedule', '/broadcastings/broadcasting' + this.broadcastingid, [new BRoute('broadcastings-page.broadcastings', '/broadcastings'), new BRoute('broadcastings-page.broadcasting detail', '/broadcasting/' + this.broadcastingid), new BRoute('schedule-page.new schedule')]));
  }

  ngOnDestroy() {
    if (this.getBroadcastingInfoSubscription) { this.getBroadcastingInfoSubscription.unsubscribe(); }
  }
}
